var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5128_7922)"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.413 10.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 27,
    rx: 15,
    ry: 9
  }))));
};
export default SvgProfile;